export function formatTimePart(num: number): string {
  return num.toString().padStart(2, '0')
}

export function getFormattedTime(minute: number, second: number): string {
  return formatTimePart(minute) + ':' + formatTimePart(second)
}

export type MinuteWithSecond = {
  minute: number
  second: number
}

export function getMinuteWithSecond(seconds: number): MinuteWithSecond {
  const minute = Math.trunc(seconds / 60) || 0 // if result is -0, assign 0
  const second = seconds % 60 || 0 // if result is -0, assign 0

  return {
    minute,
    second,
  }
}

export function getValidMinuteWithSecond(
  seconds: number,
  maxMinute?: number,
): MinuteWithSecond {
  const { minute, second } = getMinuteWithSecond(seconds > 0 ? seconds : 0)

  if (maxMinute !== undefined && minute >= maxMinute) {
    return {
      minute: maxMinute,
      second: 0,
    }
  }

  return {
    minute,
    second,
  }
}
